import PageShell from "@/components/PageShell";
import { Zap, Link2, QrCode, Radar, Webhook, Palette, LayoutDashboard, Banknote, RefreshCw } from "lucide-react";

const ITEMS = [
  { icon: Zap, title: "Kripto Ödemeleri", desc: "BTC, ETH, USDT, USDC ve SOL dahil popüler kripto paralarla ödeme kabul edin. TL üzerinden fiyatlandırın, kripto olarak tahsil edin." },
  { icon: Link2, title: "Ödeme Linkleri", desc: "Ürün adı, fiyat ve görsel ekleyerek paylaşılabilir ödeme linkleri oluşturun. Kullanım limiti ve son kullanma tarihi belirleyin." },
  { icon: QrCode, title: "QR ile Ödeme", desc: "Her ödeme için otomatik QR kod. Müşterileriniz mobil cüzdanlarıyla saniyeler içinde ödeme yapar." },
  { icon: Radar, title: "Anında Ödeme Algılama", desc: "Blockchain üzerindeki ödemeler gerçek zamanlı algılanır ve doğrulanır." },
  { icon: Webhook, title: "API & Webhook", desc: "Güçlü REST API ve imzalı webhook'lar ile sisteminizi Coinbuy'a bağlayın." },
  { icon: Palette, title: "Özelleştirilebilir Checkout", desc: "Logo, renk, yazı tipi ve düzeni markanıza göre ayarlayın. Canlı önizleme ile anında görün." },
  { icon: LayoutDashboard, title: "Merchant Dashboard", desc: "Satışlarınızı, işlemlerinizi ve bakiyenizi tek panelden yönetin." },
  { icon: Banknote, title: "Kripto Para Çekme", desc: "Bakiyenizi desteklenen ağlar üzerinden güvenle kendi cüzdanınıza çekin." },
  { icon: RefreshCw, title: "Otomatik Ödeme Takibi", desc: "Ödeme durumları oluşturuldu, bekleniyor, algılandı, doğrulanıyor ve onaylandı olarak otomatik ilerler." },
];

export default function Features() {
  return (
    <PageShell title="Özellikler" subtitle="Kripto ödeme kabul etmek için ihtiyacınız olan tüm profesyonel araçlar tek platformda.">
      <div className="grid sm:grid-cols-2 gap-5">
        {ITEMS.map((f) => (
          <div key={f.title} className="rounded-2xl border border-border bg-card p-6">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <f.icon size={20} strokeWidth={1.5} />
            </span>
            <h3 className="mt-4 text-base font-bold">{f.title}</h3>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
